import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";
import ErrorHandler from "../../helpers/validation/errorHandler";

const editExperienceFailLogic = createLogic({
	type: ActionTypes.EDIT_EXPERIENCE_FAIL,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		ErrorHandler(action.errorMessage, null, controlPanelActions, dispatch);
		done();
	},
});

export default [editExperienceFailLogic];
